// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3107":"css/print","6170":"css/app","7352":"css/app-vueform"}[chunkId] + ".css";
};